export default "__VITE_PUBLIC_ASSET__38205a9b__"